// LICENSE : MIT
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = require("map-like"),
    MapLike = _require.MapLike;
/**
 * EventTargetMap use `eventName` and `target` as a key.
 * It means that [eventName, target] tuple object as a key.
 */


var EventTargetMap = function () {
    function EventTargetMap() {
        _classCallCheck(this, EventTargetMap);

        this._eventMap = new MapLike();
    }

    /**
     * @param {string} eventName
     * @param {Object} target
     * @param {*} handler
     */


    _createClass(EventTargetMap, [{
        key: "set",
        value: function set(_ref, handler) {
            var _ref2 = _slicedToArray(_ref, 2),
                eventName = _ref2[0],
                target = _ref2[1];

            var targetMap = this._getTargetMap(eventName);
            targetMap.set(target, handler);
        }

        /**
         *
         * @param {string} eventName
         * @param {Object} target
         * @returns {MapLike}
         */

    }, {
        key: "get",
        value: function get(_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                eventName = _ref4[0],
                target = _ref4[1];

            var targetMap = this._getTargetMap(eventName);
            return targetMap.get(target);
        }

        /**
         * @param {string} eventName
         * @param {Object} target
         * @returns {boolean}
         */

    }, {
        key: "has",
        value: function has(_ref5) {
            var _ref6 = _slicedToArray(_ref5, 2),
                eventName = _ref6[0],
                target = _ref6[1];

            var targetMap = this._getTargetMap(eventName);
            return targetMap.has(target);
        }

        /**
         * @param {function(target,eventName)}handler
         */

    }, {
        key: "forEach",
        value: function forEach(handler) {
            this._eventMap.forEach(function (targetMap, eventName) {
                targetMap.forEach(function (targetEventEmitter, target) {
                    handler(target, eventName);
                });
            });
        }

        /**
         * @param {string} eventName
         * @param {Object} target
         * @returns {boolean}
         */

    }, {
        key: "delete",
        value: function _delete(_ref7) {
            var _ref8 = _slicedToArray(_ref7, 2),
                eventName = _ref8[0],
                target = _ref8[1];

            var targetMap = this._getTargetMap(eventName);
            if (targetMap) {
                targetMap.delete(target);
            }
        }

        /**
         *
         * @param {string} eventName
         * @returns {MapLike} targetMap
         * @private
         */

    }, {
        key: "_getTargetMap",
        value: function _getTargetMap(eventName) {
            var targetMap = this._eventMap.get(eventName);
            if (!targetMap) {
                targetMap = new MapLike();
                this._eventMap.set(eventName, targetMap);
            }
            return targetMap;
        }
    }]);

    return EventTargetMap;
}();

exports.default = EventTargetMap;
//# sourceMappingURL=EventTargetMap.js.map